// extracted by mini-css-extract-plugin
module.exports = {"searchBoxRainbow":"rainbowStyle_searchBoxRainbow__oftn_","borderAnimation":"rainbowStyle_borderAnimation__3MjQS","inputWrapperRainbow":"rainbowStyle_inputWrapperRainbow__dFIbv"};